import React from 'react';
import classes from './SingleProfile.module.css'
import EditModal from '../EditJobProfile/EditJobProfile'
import edit from '../../../Assets/icons/1.5x/edithdpi.png'
import del from '../../../Assets/icons/1.5x/delete@2x.png'
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import ViewJobProfile from '../ViewJobProfile/ViewJobProfile'
import { connect } from 'react-redux';
import * as actionTypes from '../../../Action/Index'



class SingleProfile extends React.Component{
    
    state = {
        modalShow: false,
        viewProfileModal:false,
        id:"",
        viewSingleData:{},
        candidateId: ''
    }

    setModalShow = (boolean, id, jobId) => {
       this.setState({
           modalShow: boolean,
           candidateId: id,
           jobId: jobId
       })
    }

    viewJobProfileModal = (boolean) => {
        this.setState({
            viewProfileModal:boolean
        })
     }


    archiveHandler= (id,page)=>{
        this.props.confirmsweetAlertModalHandler(true)
        this.props.confirmActionId(id)
    }
     skills = "";
    render(){
        //console.log('job',this.props.jobProfileDetails, this.props.updateJobProfile)
        return(
            <>
            <tbody>
                {this.props.jobProfileDetails.map(element=>{
                  
                 
                    const must  = element.allJobSkillsWithPreecedence.map((el,index)=>{
                        return index==element.allJobSkillsWithPreecedence.length ? el.value.trim(): " "+el.value.trim()
                      }
                    )
                   
                   
                    this.skills = must.join();
                   
                    const months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                    let current_datetime = new Date(element.created/1000)
                    let formatted_date = current_datetime.getDate() + " " + months[current_datetime.getMonth()]
                    
                    return (
                    <tr key={element.id} className={classes.row1} onClick={() => this.props.candidateDownloadFile(element.candidateId)}>
                    <td onClick={() => {this.viewJobProfileModal(true); this.setState({viewSingleData:element})}}
                     style={{
                        maxWidth: "25vw",
                    minWidth: "25vw",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    paddingRight: "30px",
                         }}>{element.jobTitle}
                     </td>
                    <td onClick={() => {this.viewJobProfileModal(true); this.setState({viewSingleData:element})}} >{element.minExperience} {element.minExperience > 1 ? `years` : 'year'} {element.maxExperience} {element.maxExperience > 1 ? 'months' : 'month'}</td>
                    <td onClick={() => {this.viewJobProfileModal(true);  this.setState({viewSingleData:element})}} style={{paddingRight:"1px",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', minWidth: '25vw', maxWidth:'25vw'}}>{this.skills}
                    </td>
                    <td onClick={() => {this.viewJobProfileModal(true);  this.setState({viewSingleData:element})}} style={{paddingRight:"1px",whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', minWidth: '5vw', maxWidth:'5vw'}}>{formatted_date}</td>
                    <td ><img title="Edit" alt='imag' type="image/svg+xml" src={edit} style={{marginRight:"15px",cursor:"pointer"}} onClick={() => {this.setModalShow(true, element.candidateId, element.id) ; this.setState({id:element.id,viewSingleData:element})}} />
                    <img alt='imag' title="Delete" type="image/svg+xml" onClick={(event)=>{this.archiveHandler(element.id, 1); event.stopPropagation()}} src={del} style={{cursor:"pointer"}}/></td>
                    </tr>
                   )
                })}
            </tbody>
            {
                this.state.modalShow ?
                <EditModal
                show={this.state.modalShow}
                onHide={() => this.setModalShow(false)}
                updateJobProfile={this.props.updateJobProfile}
                id={this.state.id}
                candidateId={this.state.candidateId}
                jobId={this.state.jobId}
                viewSingleData={this.state.viewSingleData}
                page={this.props.page}
                createsweetAlertModalHandler={this.props.createsweetAlertModalHandler}
                />:
                null
            }
            
            <ViewJobProfile
                show={this.state.viewProfileModal}
                hideJobProfileModal={()=>this.viewJobProfileModal(false)}
                id={this.state.id}
                viewSingleData={this.state.viewSingleData}
            />
            </>
        )
    }      
}

const mapStateToProps = state => {
    return{
    }
}

const mapDispatchToProps = dispatch => {
    return{
        candidateDownloadFile: (id)=> dispatch(actionTypes.candidateDownloadFile(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleProfile)